export default "__VITE_ASSET__bd44a324__"